export var SqlSetupCheckStatus;
(function (SqlSetupCheckStatus) {
    SqlSetupCheckStatus["SQL_SETUP_CHECK_STATUS_NOT_RUN"] = "NOT_RUN";
    SqlSetupCheckStatus["SQL_SETUP_CHECK_STATUS_IN_PROGRESS"] = "IN_PROGRESS";
    SqlSetupCheckStatus["SQL_SETUP_CHECK_STATUS_OK"] = "OK";
    SqlSetupCheckStatus["SQL_SETUP_CHECK_STATUS_INCOMPLETE"] = "INCOMPLETE";
    SqlSetupCheckStatus["SQL_SETUP_CHECK_STATUS_FAILED"] = "FAILED";
})(SqlSetupCheckStatus || (SqlSetupCheckStatus = {}));
